import { FUNCTIONALITY_COMING_SOON } from '../utils/constants';
import { toastController, ToastOptions } from '@ionic/core';
import i18n from "../../i18n";
enum Position {
  TOP = 'top',
  BOTTOM = 'bottom',
  CENTER = 'center'
}

/* Show toast Message */
export class ToastMessage {
  static show = async (
    message: string = i18n.t(FUNCTIONALITY_COMING_SOON),
    duration = 3000
  ) => {
    const toast = await toastController.create({
      color: 'dark',
      duration,
      message,
      position: 'bottom',
      mode: 'ios',
      cssClass: 'toaster-message'
    });
    await toast.present();
  };
  static showWeb = async (
    message: string = i18n.t(FUNCTIONALITY_COMING_SOON),
    duration = 3000
  ) => {
    const toast = await toastController.create({
      color: 'dark',
      duration,
      message,
      position: 'bottom',
      mode: 'md',
    });
    await toast.present();
  };
  static open = async ({ ...args }) => {
    let options: ToastOptions = {
      color: 'dark',
      duration: args.duration || 3000,
      message: args.message,
      position: 'bottom',
      mode: 'ios',
      cssClass: 'toaster-message'
    };
    if (args.showUndo) {
      options = {
        ...options,
        buttons: [
          {
            text: args.btnTitle || 'Undo',
            cssClass: 'toast-message-btn',
            handler: () => args.callback()
          }
        ]
      };
    }

    const toast = await toastController.create(options);
    await toast.present();
  };
}
